import React from 'react';

import {useStore} from 'effector-react';
import i18next from 'i18next';
import {useTranslation} from 'react-i18next';

import {validateCode} from 'api';
import {BackTo} from 'components/common/BackTo';
import {Stepper} from 'components/ui-kit/Stepper';
import {DocumentReportType} from 'core/dictionaries';
import {ROUTE} from 'core/routes';
import {
    createDropOutDocument,
    DocumentsCreateGate,
    dropOutForm$,
    step$,
} from 'models/documents/create';

import {CodeRequestType, CodeResponseType} from 'types/validation';

import {ProductCodes} from '../common/products';
import {ContentWrapper} from '../common/styled';

import {DocumentForm} from './form';

export const CreateDropOut = () => {
    const {t} = useTranslation();
    const step = useStore(step$);
    const dropoutForm = useStore(dropOutForm$);

    const validation = async (markingCode: string, data: CodeResponseType['info'][]) => {
        const errors: string[] = [];

        try {
            const payload: CodeRequestType = {
                dropoutReason: dropoutForm.reason,
                salesChannel: dropoutForm.salesChannel || undefined,
                type: DocumentReportType.DROPOUT,
                markingCode,
            };
            const codeData = (await validateCode(payload)).data;
            errors.push(...codeData.errors.map((e) => e.message));

            if (data.find((d) => d.identityCode === codeData.info.identityCode))
                errors.push(i18next.t('components.scan.errors.double'));

            return {errors, codeData: codeData.info};
        } catch (e) {
            console.error(e);
            errors.push('Invalid code');
            return {errors, codeData: null};
        }
    };

    return (
        <>
            <BackTo to={ROUTE.DOCUMENTS_WITHDRAWAL}>{t('pages.documents.back')}</BackTo>
            <ContentWrapper>
                <h1>{t('pages.documents.newDocumentDropOut')}</h1>
                <DocumentsCreateGate />
                <Stepper
                    steps={[
                        {
                            label: t('pages.documents.stepOne'),
                            component: <DocumentForm />,
                        },
                        {
                            label: t('pages.documents.stepTwo'),
                            component: (
                                <ProductCodes
                                    createDocument={createDropOutDocument}
                                    validation={validation}
                                />
                            ),
                        },
                    ]}
                    activeStep={step}
                />
            </ContentWrapper>
        </>
    );
};
